export type AdminAction =
  | { type: 'nav'; at: number; path: string }
  | { type: 'request'; at: number; method: string; url: string; status?: number; ms?: number; ok?: boolean };

const CAP = 200;
let buf: AdminAction[] = [];

export function logAction(a: AdminAction) {
  buf.push(a);
  if (buf.length > CAP) buf = buf.slice(buf.length - CAP);
}

export function getRecentActions(limit = 12): AdminAction[] {
  const n = Math.max(1, Math.min(limit, CAP));
  return buf.slice(-n);
}
